export default __webpack_public_path__ + "static/media/45t.0b192bf4.jpg";